// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

/* Filters */

var hq = angular.module('hqFilters', []);

hq.filter('pdate', ['$filter', function ($filter) {
    return function (input, format) {
        if (!input) return "";

        if (input instanceof Date) input = input.toISOString();
        if (format === "logTimestamp") format = "yyyy-MM-ddTHH:mm:ssZ";
        
        return $filter('date')(("" + input).replace('0000Z', 'Z'), format);
    }
}]);

hq.filter('prettyRequestData', ['$filter', function ($filter) {
    return function (input, format) {
        if (input) {
            return input.replace(/&/g, '\n');
        }
        else
            return "";
    }
}]);
hq.filter('checkmark', function() {
  return function(input) {
    return input ? '\u2713' : '\u2718';
  };
});

hq.filter('prettyJSON', function () {
    function syntaxHighlight(json) {
        var pretty = prettyPrintOne(json);
        return pretty;
    }
    return syntaxHighlight;
});

hq.filter('unsafe', function ($sce) {
    function trust(html) {
        var trustedHtml = $sce.trustAsHtml(html);
        return trustedHtml;
    }
    return trust;
});

hq.filter('range', function () {
    return function (input, total) {
        total = parseInt(total);
        for (var i = 0; i < total; i++)
            input.push(i);
        return input;
    };
});

hq.filter('idCreated', function () {
    return function (input) {
        return new Date(parseInt(input.slice(0, 8), 16) * 1000);
    };
});

hq.filter('cutUrl', function () {
    return function (input) {
        if (!input.substring)
            return input;

        let cutTo = Math.min(input.length, 75);
        if (cutTo >= input.length)
            return input;
        
        return input.substring(0, cutTo) + "...";
    };
});

hq.filter('allowEmptyFilter', function () {
    return function (items, filterObject) {
        if (!filterObject) {
            return items; // Show all items when filter is empty
        }
        
        for (var prop in filterObject) {
            var val = filterObject[prop];
            if (!filterObject.hasOwnProperty(prop) || !val || val === '')
                delete filterObject[prop];            
        }

        if (Object.keys(filterObject).length === 0)
            return items;
        
        var filtered = [];

        angular.forEach(items, function (item) {
            var isMatch = true;

            for (var prop in filterObject) {
                if (item[prop] &&
                    item[prop].toString().toLowerCase().indexOf(filterObject[prop].toString().toLowerCase()) === -1
                ) {
                    isMatch = false; // Set isMatch to false if any property doesn't match
                    break;
                }
            }

            if (isMatch) {
                filtered.push(item); // Add the item to the filtered array if all properties match
            }
        });

        return filtered;
    };
});



